module.exports = __webpack_public_path__ + "static/img/catec.3a45981e.png";